import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, NgModel, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;
declare var External: any;

@Component({
	selector: 'app-survey-pricing',
	templateUrl: './survey-pricing.component.html',
	styleUrls: ['./survey-pricing.component.css']
})
export class SurveyPricingComponent implements OnInit {
	surveyPurchaseForm;
	paypalConfigurationForm;
	twilioConfigurationForm;
	setting_id: any = null;
	trxnMode:any;
	paypalConfgId:boolean;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		this.commonService.process();
		setTimeout(function(){ External.ValidateNumber('app_purchase'); }, 0);
		$(".navbar-brand").text("Survey Pricing");

		this.paypalConfigurationForm = new FormGroup({
			paypal_mode: new FormControl("", Validators.compose([
				//Validators.required
			])),

			paypal_key: new FormControl("", Validators.compose([
				Validators.required
			])),
		});
		this.twilioConfigurationForm = new FormGroup({
			accountSid: new FormControl("", Validators.compose([
				//Validators.required
			])),

			authToken: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		this.surveyPurchaseForm = new FormGroup({
			country_post_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_post_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_post_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_post_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_post_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_post_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_post_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_post_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),
			city_post_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_post_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_post_yearly_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			])),

			city_post_yearly_top_survey_amount: new FormControl("", Validators.compose([
				Validators.required
			]))

		});
		this.getAppPurchaseData();
		this.getPaypalConfigurationData();
		this.getSettings();
	}

	
	// Get app purchase data
	getAppPurchaseData = function(){
		this.authService.getAppPurchaseData().subscribe(data=>{
			if(data.success){
			debugger
				this.appPurchaseId = data.amount._id;
				this.surveyPurchaseForm.controls['country_post_survey_amount'].setValue(data.amount.country_post_survey_amount);
				this.surveyPurchaseForm.controls['country_top_survey_amount'].setValue(data.amount.country_top_survey_amount);
				this.surveyPurchaseForm.controls['country_yearly_survey_amount'].setValue(data.amount.country_yearly_survey_amount);
				this.surveyPurchaseForm.controls['country_post_top_survey_amount'].setValue(data.amount.country_post_top_survey_amount);
				this.surveyPurchaseForm.controls['country_post_yearly_survey_amount'].setValue(data.amount.country_post_yearly_survey_amount);
				this.surveyPurchaseForm.controls['country_yearly_top_survey_amount'].setValue(data.amount.country_yearly_top_survey_amount);
				this.surveyPurchaseForm.controls['country_post_yearly_top_survey_amount'].setValue(data.amount.country_post_yearly_top_survey_amount);

				this.surveyPurchaseForm.controls['world_post_survey_amount'].setValue(data.amount.world_post_survey_amount);
				this.surveyPurchaseForm.controls['world_top_survey_amount'].setValue(data.amount.world_top_survey_amount);
				this.surveyPurchaseForm.controls['world_yearly_survey_amount'].setValue(data.amount.world_yearly_survey_amount);
				this.surveyPurchaseForm.controls['world_post_top_survey_amount'].setValue(data.amount.world_post_top_survey_amount);
				this.surveyPurchaseForm.controls['world_post_yearly_survey_amount'].setValue(data.amount.world_post_yearly_survey_amount);
				this.surveyPurchaseForm.controls['world_yearly_top_survey_amount'].setValue(data.amount.world_yearly_top_survey_amount);
				this.surveyPurchaseForm.controls['world_post_yearly_top_survey_amount'].setValue(data.amount.world_post_yearly_top_survey_amount);

				this.surveyPurchaseForm.controls['city_post_survey_amount'].setValue(data.amount.city_post_survey_amount);
				this.surveyPurchaseForm.controls['city_top_survey_amount'].setValue(data.amount.city_top_survey_amount);
				this.surveyPurchaseForm.controls['city_yearly_survey_amount'].setValue(data.amount.city_yearly_survey_amount);
				this.surveyPurchaseForm.controls['city_post_top_survey_amount'].setValue(data.amount.city_post_top_survey_amount);
				this.surveyPurchaseForm.controls['city_post_yearly_survey_amount'].setValue(data.amount.city_post_yearly_survey_amount);
				this.surveyPurchaseForm.controls['city_yearly_top_survey_amount'].setValue(data.amount.city_yearly_top_survey_amount);
				this.surveyPurchaseForm.controls['city_post_yearly_top_survey_amount'].setValue(data.amount.city_post_yearly_top_survey_amount);
			}
			this.commonService.hideProcess();
		});
	}

	//get Settings
	getSettings() {
			// debugger;;
	this.commonService.process();
	this.authService.getSettings().subscribe(data => {
		console.log(data)
				 //debugger;;
		if (data.success) {
			console.log(data)
			this.setting_id = data.settings[0]._id;
			this.twilioConfigurationForm.controls['accountSid'].setValue(data.settings[0].twilio.accountSid);
			this.twilioConfigurationForm.controls['authToken'].setValue(data.settings[0].twilio.authToken);
			// 		//debugger;;
			// this.scoreForm.controls['world_score'].setValue(data.settings[0] ? data.settings[0].world_score : '');
			// this.scoreForm.controls['country_score'].setValue(data.settings[0] ? data.settings[0].country_score : '');
			// this.scoreForm.controls['city_score'].setValue(data.settings[0] ? data.settings[0].city_score : '');
			// this.scoreForm.controls['videoonuserquestion'].setValue(data.settings[0] ? data.settings[0].videoonuserquestion : '');
			// this.scoreForm.controls['videoonwazaskquestion'].setValue(data.settings[0] ? data.settings[0].videoonwazaskquestion : '');
			// this.censored_words = data.settings[0] ? data.settings[0].censored : '';
			// this.setting_id = data.settings[0]._id;
			// this.criteriaOneForm.controls['packageName'].setValue(data.settings[0].criteriaOne.planName);
			// this.criteriaOneForm.controls['favCount'].setValue(data.settings[0].criteriaOne.favoriteCount);
			// this.criteriaOneForm.controls['likeCount'].setValue(data.settings[0].criteriaOne.likeCount);
			// this.criteriaOneForm.controls['amount'].setValue(data.settings[0].criteriaOne.amount);

			// this.criteriaTwoForm.controls['packageName'].setValue(data.settings[0].criteriaTwo.planName);
			// this.criteriaTwoForm.controls['favCount'].setValue(data.settings[0].criteriaTwo.favoriteCount);
			// this.criteriaTwoForm.controls['likeCount'].setValue(data.settings[0].criteriaTwo.likeCount);
			// this.criteriaTwoForm.controls['amount'].setValue(data.settings[0].criteriaTwo.amount);

			// setTimeout(function () {
			// 	External.LoadTagInput();
			// }, 100);
		}

		else {
			jQuery.growl.error({ title: 'Error', message: data.error });
		}
		this.commonService.hideProcess();
	});
}

	// Submit App Purchase Form
	submitAppPurchaseForm = function(){
		debugger;
		if(this.surveyPurchaseForm.valid){
			jQuery("button.app_purchase").text('Saving...').attr('disabled',true);
			this.authService.appPurchase(this.surveyPurchaseForm.value, this.appPurchaseId).subscribe(data=>{
				debugger;
				if(data.success)
					jQuery.growl.notice({ title: 'Success', message: data.message });
				else
					jQuery.growl.error({ title: 'Error', message: data.error });
				jQuery("button.app_purchase").text('Save').attr('disabled',false);
			});
		}
		else{
			this.validationService.validateAllFormFields(this.surveyPurchaseForm);
		}
	}

	// Save Paypal Configuration
	savePaypalConfiguration = function(data){
		if(this.paypalConfigurationForm.valid){
			jQuery("button.btn_paypal_configuration").text('Saving...').attr('disabled',true);
			if($("#paypalMode").prop('checked') == true)
				this.trxnMode = 'production';
			else
				this.trxnMode = 'sandbox';
			data.paypal_mode = this.trxnMode;
			this.authService.savePaypalConfiguration(data,this.paypalConfgId).subscribe(data=>{
				if(data.success){
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else{
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.btn_paypal_configuration").text('Save').attr('disabled',false);
			});
		}
		else{
			this.validationService.validateAllFormFields(this.paypalConfigurationForm);
		}
	}

		// Save Twilio Configuration
		saveTwilioConfiguration = function(data){
			console.log(data)
			data._id = this.setting_id
			console.log(data)
			if(this.twilioConfigurationForm.valid){
				 jQuery("button.btn_twilio_configuration").text('Saving...').attr('disabled',true);
				// if($("#paypalMode").prop('checked') == true)
				// 	this.trxnMode = 'production';
				// else
				// 	this.trxnMode = 'sandbox';
				// data.paypal_mode = this.trxnMode;
				this.authService.saveTwilioConfiguration(data,).subscribe(data=>{
					if(data.success){
						jQuery.growl.notice({ title: 'Success', message: data.message });
					}
					else{
						jQuery.growl.error({ title: 'Error', message: data.error });
					}
					jQuery("button.btn_twilio_configuration").text('Save').attr('disabled',false);
				});
			}
			else{
				this.validationService.validateAllFormFields(this.twilioConfigurationForm);
			}
		}

	// Paypal Mode
	paypalMode = function(){
		if($("#paypalMode").prop('checked') == true)
			this.trxnMode = 'production';
		else
			this.trxnMode = 'sandbox';
	}

	// Get paypal COnfiguration data
	getPaypalConfigurationData = function(){
		this.authService.getPaypalConfigurationData().subscribe(data=>{
			if(data.success){
				this.paypalConfgId = data.paypalConfigList._id;
				if(data.paypalConfigList.paypal_mode=='production')
					$('div.checkbox.chk').trigger('click'); 
				this.paypalConfigurationForm.controls['paypal_key'].setValue(data.paypalConfigList.paypal_key);
			}
		});
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/survey-pricing/survey-pricing.component.ts